import { Module } from 'vuex-module-decorators'
import SalesCartAbstract from '~/store/sales-cart-abstract'

@Module({
  name: 'sales-cart-order',
  stateFactory: true,
  namespaced: true,
})
export default class SalesCartOrder extends SalesCartAbstract {}
